import React, { useState, useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { FaMapMarkerAlt } from "react-icons/fa";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel"; // Added import
import Select from "@mui/material/Select";
import whatsapp from "../utils/whatsapp.png";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import SubjobsGrid from "./SubjobsGrid";
import SubjobsGridEntryForm from "./SubjobsGridEntryForm";
import InputAdornment from "@mui/material/InputAdornment";
import { Add, AddCircleOutline, Create, PostAdd } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import {
  Alert,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import OfficeJobForm from "./OfficeJobForm";

const NewJobForm = () => {
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#65C466",
          opacity: 1,
          border: 0,
          ...(theme.palette.mode === "dark" && {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...(theme.palette.mode === "dark" && {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...(theme.palette.mode === "dark" && {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 13,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...(theme.palette.mode === "dark" && {
        backgroundColor: "#39393D",
      }),
    },
  }));

  useEffect(() => {
    fetchJobTypeList();
  }, []);

  const [jobTypeList, setJobTypeList] = useState(null);
  const [leadNumberFromAPI, setLeadNumberFromAPI] = useState("000000");
  const [officeJobView, setOfficeJobView] = useState(false);
  const [normalJobView, setNormalJobView] = useState(false);

  const fetchJobTypeList = async () => {
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskStageList/CUBIX/JOBTYPELIST/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      setJobTypeList(data);
    } catch (err) {
      console.error("Error while fetching assign members", err);
    }
  };

  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("formData");
    return saved
      ? JSON.parse(saved)
      : {
          organization: "",
          email: "",
          phone: "",
          isPhoneWhatsApp: false,
          alternatePhone: "",
          isAlternatePhoneWhatsApp: false,
          lead: "",
          status: "",
          title: "",
          notes: "",
          // leadNumber: leadNumberFromAPI,
          leadNumber: "0000000",
          coordinator: "",
          salesperson: "",
          campaignId: "",
          departmentNo: "",
          probability: "",
          currency: "",
          bookedAmount: "",
          country: "",
          comments: "",
          attachment: null,
          jobType: "",
          jobDescription: "",
          territory: "",
          streetAddress: "",
          city: "",
          apartment: "",
          area: "",
          // location: "",
          priority: 0,
          account: "",
        };
  });
  const [showDropdown, setShowDropdown] = useState(false);
  const [showNameListDropdown, setShowNameListDropdown] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [productEntries, setProductEntries] = useState([]);

  const [duplicateItemCodeSnackbar, setDuplicateItemCodeSnackbar] =
    useState(false);
  const [errorRow, setErrorRow] = useState(0);
  const [subjobList, setSubjobList] = useState(null);
  const dropdownRef = useRef(null);
  const dropdownListRef = useRef(null);
  const navigate = useNavigate();

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const nameRegex = /^[a-zA-Z\s]{2,50}$/;

  useEffect(() => {
    localStorage.setItem("formData", JSON.stringify(formData));
  }, [formData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handlePriorityClick = (level) => {
    setFormData((prev) => ({
      ...prev,
      priority: level,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("formData", formData);
    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment"
    );

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentUserName = localStorage.getItem("currentUserName")
      ? localStorage.getItem("currentUserName")
      : "-";

    const newJobPayload = productEntries.map((item) => ({
      CmpCode: company_code_from_local_storage,
      mode: "ENTRY",
      Job_id: 1001, //backend
      Job_entryTime: "2025-07-22T10:00:00", //backend
      // Job_creatorid: "user01//", //dynamic
      Job_creatorid: currentUserName, //dynamic
      Job_salesperson: formData.salesperson || "",
      Job_account: formData.account || "",
      Job_organization: formData.organization || "",
      Job_notes: formData.notes || "",
      Job_country: formData.country || "",
      Job_city: formData.city || "",
      Job_territory: formData.territory || "",
      Job_area: formData.area || "",
      Job_streetaddress: formData.streetAddress || "",
      Job_location: formData.location || "",
      Job_appartment: formData.apartment || "",
      Job_primarycontact: formData.lead || "",
      Job_primarycontacttitle: formData.title || "",
      Job_phone: formData.phone || "",
      Job_isphonewhatsapp: formData.isPhoneWhatsApp || "",
      Job_alt_phone: formData.alternatePhone || "",
      Job_alt_isphonewhatsapp: formData.isAlternatePhoneWhatsApp || "",
      Job_email: formData.email || "",
      Job_stage: "", //lead number need
      Job_priority: formData.priority + "" || "",
      Job_status: formData.status || "",
      Job_Type: formData.jobType || "",
      Job_bookedamount: formData.bookedAmount || 0,
      Job_currencycode: formData.currency || "",
      Job_currencyrate: 1.0,
      Task_CreateTime: "2025-07-22T11:00:00", //backend
      // Task_Description: formData.jobDescription || "",
      Task_Description: item.Task_Description || "",
      Task_Group: item.task_group || "",
      // Task_AssignedTo: "emp05//",
      Task_AssignedTo: "", //backend
      // Task_Instructions: "Prepare proposal document//",
      Task_Instructions: "",
      Task_ScheduleDateTime: "2025-07-23T10:00:00",
      Task_TargetDateTime: "2025-07-25T17:00:00",
      Task_LastActionDateTime: "2025-07-21T15:30:00",
      Task_status: "Unassigned",
      Task_Comments: formData.comments || "",
      // Task_Serial: 1,
      Task_Serial: item.Task_Serial || "",
      // deptno: "MAIN",
      deptno: currentDepartmentFromLocalStorage,
    }));

    console.log("payload tro send for new job:", newJobPayload);

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    // console.log('apiPaths_from_local_storage',apiPaths_from_local_storage)

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRM_JobRegister`;

    try {
      const response = await axios.post(apiUrl, newJobPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("response after posting new job", response);
      const data = response.data;
      console.log("data after posting new job", data);
      setOpenSubmitSnackbar(true);
      localStorage.removeItem("formData");
      setTimeout(() => {
        navigate("/jobs");
      }, 800);
    } catch (err) {
      console.error("Error while posting new job", err);
      setOpenSnackbar(true);
    }

    // setOpenSubmitSnackbar(true);
  };

  const cancelForm = () => {
    localStorage.removeItem("formData");

    setFormData({
      organization: "",
      email: "",
      phone: "",
      isPhoneWhatsApp: false,
      alternatePhone: "",
      isAlternatePhoneWhatsApp: false,
      lead: "",
      status: "newJob",
      title: "",
      notes: "",
      // leadNumber: "", //
      coordinator: "", //
      salesperson: "",
      campaignId: "", //
      departmentNo: "", //
      probability: "", //
      currency: "",
      bookedAmount: "",
      country: "",
      comments: "",
      attachment: null, //
      jobType: "",
      jobDescription: "",
      territory: "",
      streetAddress: "",
      city: "",
      apartment: "",
      area: "",
      // location: "",
      priority: 0,
      account: "",
    });
  };

  const backForm = () => {
    navigate("/jobs");
  };

  const onNewTemplate = () => {
    navigate("/templates");
  };

  const isFormValid =
    formData.jobType &&
    formData.organization &&
    // formData.lead &&
    // formData.email &&
    // emailRegex.test(formData.email) &&
    formData.phone;
  // formData.leadNumber
  // formData.salesperson &&
  // formData.status;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, attachment: file });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    // setDuplicateItemCodeSnackbar(false);
  };

  //   const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  const handleJobTypeChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    console.log("jobtype selected", e.target.value);
    const selectedJobType = e.target.value;
    fetchSubJobList(selectedJobType);
  };

  const fetchSubJobList = async (selectedJobType) => {
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskStageList/CUBIX/SUBJOBLIST/${selectedJobType}`;
    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("subjob list:", data);
      setSubjobList(data);
      setProductEntries(data);
    } catch (err) {
      console.log("Error while fetching subjob list", err);
    }
  };

  return (
    <div className="flex justify-center items-center">
      <form className="bg-white rounded-lg px-4 pt-2 w-full shadow">
        <div className="flex justify-between items-center">
          <div className="flex justify-between items-center w-full">
            <button
              onClick={backForm}
              className="text-gray-700 hover:bg-gray-300 px-1 py-2 my-2 rounded transition"
            >
              <ArrowLeft className="w-8 h-6" />
            </button>
            <h2 className="text-2xl font-normal text-center my-2 text-gray-600">
              {formData.isEditinglead ? "Edit Job" : "Job Entry Form"}
            </h2>
            <div className="flex flex-col">
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={officeJobView}
                    className="mr-4"
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setOfficeJobView(checked);
                      setNormalJobView(!checked);

                      // if (checked) {
                      //   setSelectedStage("");
                      // }
                    }}
                  />
                }
                // label="Office job"
                label="In-house job"
              />
            </div>
          </div>
        </div>

        {false && ( // Placeholder for Snackbar logic (to be implemented if needed)
          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={() => setOpenSnackbar(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={() => setOpenSnackbar(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {`Item Code is not Correct at row ${errorRow}`}
            </MuiAlert>
          </Snackbar>
        )}
        {false && ( // Placeholder for Snackbar logic (to be implemented if needed)
          <Snackbar
            open={openSubmitSnackbar}
            autoHideDuration={3000}
            onClose={() => setOpenSubmitSnackbar(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={() => setOpenSubmitSnackbar(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              Form Submitted Successfully!
            </MuiAlert>
          </Snackbar>
        )}
        {false && ( // Placeholder for Snackbar logic (to be implemented if needed)
          <Snackbar
            open={duplicateItemCodeSnackbar}
            autoHideDuration={3000}
            onClose={() => setDuplicateItemCodeSnackbar(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={() => setDuplicateItemCodeSnackbar(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              This item is already selected. Duplicate entries are not allowed!
            </MuiAlert>
          </Snackbar>
        )}

        {officeJobView ? (
          <OfficeJobForm />
        ) : (
          <div className="leadFormDivAllEntries grid grid-cols-4 gap-4">
            <div className="mb-0 relative" ref={dropdownRef}>
              <TextField
                label="Customer / Organization"
                name="organization"
                required
                value={formData.organization}
                onChange={(e) => {
                  handleChange(e);
                  setShowDropdown(true);
                }}
                placeholder="Enter Customer / Organization"
                fullWidth
                variant="standard"
                id="standard"
                autoComplete="off"
                error={!formData.organization}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
              {false && ( // Placeholder for dropdown (to be implemented if needed)
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300">
                  {/* Dropdown content */}
                </div>
              )}
            </div>

            <div className="flex justify-between items-center">
              <div className="mb-0 w-[85%]">
                <TextField
                  label="Phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter Phone Number"
                  fullWidth
                  required
                  variant="standard"
                  id="standard"
                  error={!formData.phone}
                  sx={{
                    "& .MuiInputLabel-root": {
                      fontFamily: "Figtree, sans-serif",
                    },
                    "& .MuiInputBase-input:focus": {
                      boxShadow: "none !important",
                    },
                    width: "100%",
                  }}
                />
              </div>
              <div>
                <div className="flex justify-center items-center gap-2">
                  <img
                    src={whatsapp}
                    alt="whatsapp-icon"
                    className="w-5 h-5 object-contain"
                  />
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow cursor-pointer"
                    name="isPhoneWhatsApp"
                    checked={formData.isPhoneWhatsApp}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
            </div>

            <div className="mb-0">
              <TextField
                label="Lead Number"
                name="leadNumber"
                readOnly
                value={formData.leadNumber}
                onChange={handleChange}
                fullWidth
                // required
                // error={!formData.leadNumber}
                // helperText={formData.leadNumber ? "Required Lead Number" : ""}
                variant="standard"
                id="standard"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">#</InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>

            <div className="mb-0">
              <TextField
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email"
                fullWidth
                // required
                variant="standard"
                id="standard"
                // error={!formData.email || !emailRegex.test(formData.email)}
                // helperText={
                //   formData.email && !emailRegex.test(formData.email)
                //     ? "Enter a valid email address (e.g., example@domain.com)"
                //     : ""
                // }
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>

            <div className="mb-0">
              <TextField
                select
                label="Status"
                name="status"
                // value={formData.status}
                value={"newJob"}
                onChange={handleChange}
                fullWidth
                // required
                variant="standard"
                id="standard"
                // error={!formData.status}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              >
                <MenuItem value="newJob">
                  <button className="w-full bg-blue-500 text-white px-4 py-0 rounded">
                    New
                  </button>
                </MenuItem>
              </TextField>
            </div>

            <div className="mb-0 relative" ref={dropdownListRef}>
              <TextField
                label="Contact Person"
                name="lead"
                value={formData.lead}
                onChange={(e) => {
                  handleChange(e);
                  setShowNameListDropdown(true);
                }}
                placeholder="Enter Contact Name"
                fullWidth
                // required
                variant="standard"
                id="standard"
                // error={!formData.lead}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
              {false && ( // Placeholder for dropdown (to be implemented if needed)
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300">
                  {/* Dropdown content */}
                </div>
              )}
            </div>

            <div className="mb-0">
              <TextField
                disabled={false} // Placeholder; adjust based on access logic
                select
                label="Sales Person"
                name="salesperson"
                value={formData.salesperson}
                onChange={handleChange}
                fullWidth
                // required
                variant="standard"
                id="standard"
                // error={!formData.salesperson}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select Sales Person
                </MenuItem>
                {/* Placeholder; replace with salespersonList if available */}
                <MenuItem value="emp1">Sales Person 1</MenuItem>
                <MenuItem value="emp2">Sales Person 2</MenuItem>
              </TextField>
            </div>

            <div className="mb-0">
              <TextField
                select
                label="Country"
                name="country"
                value={formData.country || ""}
                onChange={handleChange}
                fullWidth
                variant="standard"
                id="country"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              >
                <MenuItem value="unitedArabEmirates">
                  United Arab Emirates
                </MenuItem>
                <MenuItem value="unitedStates">United States</MenuItem>
                <MenuItem value="unitedKingdom">United Kingdom</MenuItem>
                <MenuItem value="india">India</MenuItem>
                <MenuItem value="canada">Canada</MenuItem>
                <MenuItem value="australia">Australia</MenuItem>
                <MenuItem value="OtherCurrency">Others</MenuItem>
              </TextField>
            </div>

            <div className="mb-0">
              <TextField
                select
                label="Territory"
                name="territory"
                value={formData.territory}
                onChange={handleChange}
                fullWidth
                variant="standard"
                id="territory"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select Territory
                </MenuItem>
                <MenuItem value="dubai">Dubai</MenuItem>
                <MenuItem value="abudhabi">Abu Dhabi</MenuItem>
                <MenuItem value="sharjah">Sharjah</MenuItem>
                <MenuItem value="ajman">Ajman</MenuItem>
                <MenuItem value="otherTerritory">Others</MenuItem>
              </TextField>
            </div>

            <div className="mb-0">
              <TextField
                label="Street Address"
                name="streetAddress"
                value={formData.streetAddress || ""}
                onChange={handleChange}
                fullWidth
                variant="standard"
                id="streetAddress"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>

            <div className="mb-0">
              <TextField
                label="City"
                name="city"
                value={formData.city || ""}
                onChange={handleChange}
                fullWidth
                variant="standard"
                id="city"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>

            <div className="mb-0">
              <TextField
                label="Apartment (Optional)"
                name="apartment"
                value={formData.apartment || ""}
                onChange={handleChange}
                fullWidth
                variant="standard"
                id="apartment"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>

            <div className="mb-0">
              <TextField
                label="Area Name"
                name="area"
                type="text"
                value={formData.area}
                onChange={handleChange}
                placeholder="Enter Area name"
                fullWidth
                variant="standard"
                id="standard"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>

            {/* <div className="mb-0">
            <TextField
              label="Location"
              name="location"
              type="text"
              value={formData.location}
              onChange={handleChange}
              placeholder="Enter Location"
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div> */}

            <div></div>

            <div className="flex justify-center items-center gap-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Attachments
              </label>
              <input
                type="file"
                name="attachment"
                onChange={handleFileChange}
                className="block w-full text-sm text-gray-500
               file:mr-4 file:py-2 file:px-4
               file:rounded file:border-0
               file:text-sm file:font-semibold
               file:bg-blue-50 file:text-blue-700
               hover:file:bg-blue-100
               focus:outline-none"
              />
            </div>

            <div className="flex gap-4 items-center justify-left mb-2 ">
              <label className="block font-normal text-base text-black text-opacity-60">
                Priority
              </label>
              <div className="flex space-x-2">
                {[1, 2, 3].map((level) => (
                  <button
                    key={level}
                    type="button"
                    className={`text-2xl transition-all duration-300 ease-in-out ${
                      formData.priority >= level
                        ? "text-yellow-500 transform scale-110"
                        : "text-gray-400 transform scale-100"
                    } hover:scale-125 hover:text-yellow-500`}
                    onClick={() => handlePriorityClick(level)}
                  >
                    ★
                  </button>
                ))}
              </div>
            </div>

            <div className="mb-0">
              <TextField
                select
                label="Job Type"
                name="jobType"
                value={formData.jobType}
                // onChange={handleChange}
                onChange={handleJobTypeChange}
                fullWidth
                required
                error={!formData.jobType}
                helperText={!formData.jobType ? "Select Job Type" : ""}
                variant="standard"
                id="jobType"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              >
                <MenuItem
                  value=""
                  // className="bg-gradient-to-r from-emerald-50 via-green-50 to-teal-50 hover:from-emerald-100 hover:via-green-100 hover:to-teal-100 border border-green-200 rounded-lg mx-2 my-1 shadow-sm hover:shadow-md transition-all duration-200"
                  className="mx-2 my-1"
                  onClick={onNewTemplate}
                >
                  <div className="flex items-center gap-3 w-full py-2 bg-gradient-to-r from-emerald-100 via-green-100 to-teal-100 border border-green-200 rounded-lg shadow-sm shadow-md transition-all duration-200">
                    <div className="bg-white rounded-lg px-0.5 py-0.25 mx-2 my-1">
                      <Add className="text-green-500" fontSize="xs" />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-green-700 font-semibold text-sm">
                        Create New
                      </span>
                      {/* <span className="text-green-600/70 text-xs">Design your own template</span> */}
                    </div>
                  </div>
                </MenuItem>

                {jobTypeList &&
                  jobTypeList?.map((item, index) => (
                    <MenuItem key={item?.JOB_TYPE} value={item?.JOB_TYPE}>
                      {item?.JOB_TYPE}
                    </MenuItem>
                  ))}
              </TextField>
            </div>

            {/* <div></div> */}
            <div className="mb-0">
              <TextField
                label="Comments"
                name="comments"
                type="text"
                value={formData.comments}
                onChange={handleChange}
                placeholder="Enter Comments"
                fullWidth
                multiline
                rows={3}
                variant="standard"
                id="standard"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>

            <div className="mb-0">
              <TextField
                label="Job Description"
                name="jobDescription"
                type="text"
                value={formData.jobDescription}
                onChange={handleChange}
                placeholder="Enter Job Description"
                fullWidth
                multiline
                rows={3}
                variant="standard"
                id="standard"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            </div>
          </div>
        )}

        <div>
          {subjobList && subjobList.length > 0 ? (
            <div>
              <SubjobsGridEntryForm
                productEntries={productEntries}
                setProductEntries={setProductEntries}
              />
            </div>
          ) : (
            ""
          )}
        </div>

        {officeJobView ? (
          ""
        ) : (
          <div className="flex justify-between my-6 pb-0 gap-4">
            {formData.jobType === "" ? (
              <div className="px-4 py-2 my-2"></div>
            ) : (
              <div className="px-4 py-2 my-2"></div>
            )}

            <button
              type="submit"
              className={`text-white px-4 py-2 my-2 rounded w-40 ${
                isFormValid
                  ? "bg-blue-500 hover:bg-blue-700"
                  : "bg-gray-400 hover:bg-gray-500 cursor-not-allowed"
              }`}
              onClick={(e) => handleSubmit(e)}
              disabled={!isFormValid}
            >
              Submit
            </button>
            <button
              onClick={(e) => cancelForm(e)}
              className="text-gray-700 bg-gray-200 hover:bg-gray-300 px-4 py-2 my-2 rounded w-40 transition"
            >
              Clear All Data
            </button>
          </div>
        )}
      </form>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          Error while adding job!
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Job Submitted Successfully!
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default NewJobForm;
